import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=2c1eca95&scoped=true&"
import script from "./LabelList.vue?vue&type=script&lang=js&"
export * from "./LabelList.vue?vue&type=script&lang=js&"
import style0 from "./LabelList.vue?vue&type=style&index=0&id=2c1eca95&prod&lang=scss&scoped=true&"
import style1 from "./LabelList.vue?vue&type=style&index=1&id=2c1eca95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1eca95",
  null
  
)

export default component.exports